import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  background: #002c5f;
  color: #fff;
  font-size: 24px;
  display: table-cell;
  width: 142px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  vertical-align: middle;
  position: absolute;
  top: 0;
  right: 0;

  &:disabled {
    background: #9aa8bd;
    cursor: not-allowed;
  }
`;

const LoginButton = ({ onClick, children, disabled = false }) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled}>
      {children}
    </StyledButton>
  );
};

export default LoginButton;
